import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import routesConfig from './routes';
import { connect } from 'react-redux';
import * as actions from './store/actions/index';
import { withRouter } from 'react-router';

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignIn();
  }

  render() {
    return (
      <div className="App">
        <Switch>
          {routesConfig.map(route => {
            return (
              <Route
                key={route.path}
                exact
                path={route.path}
                component={route.component}
              />
            );
          })}
        </Switch>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  onTryAutoSignIn: () => dispatch(actions.authCheckState()),
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(App)
);
